import angular from 'angular';

angular.module('cloudX').directive('cxLanguage', [
  'optionsSvc',
  function(optionsSvc) {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<select ng-options="(language | translateList:\'language\') for language in languages" ' +
        'class="form-control">' +
        "<option value=\"\" ng-hide=\"language\">{{placeholder||('- '+('Choose'|translate)+' -')}}</option>" +
        '</select>',
      scope: {
        placeholder: '@',
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.languages = optionsSvc.getOptions('language');
        },
      ],
    };
  },
]);
